<div class="scenario-detail-section">
  <div class="flex items-center justify-between mb-8">
    <div class="card">
      <div class="flex items-center mb-2">
        <img class="top-img" src="assets/svg-icons/{{ getSiteColor(site) }}.svg" alt="{{ getSiteColor(site) }}" />
        <h1>{{ site.online ? 'Online' : 'Unavailable' }}</h1>
      </div>
      {{ 'site.availability' | translate }}
    </div>
    <div class="card">
      <div class="flex items-center mb-2">
        <img class="top-img" src="assets/svg-icons/control-mode.svg" alt="control-mode" />
        <h1>{{ site.controlMode }}</h1>
      </div>
      {{ 'site.control_mode' | translate }}
    </div>
    <div class="card">
      <div class="flex items-center mb-2">
        <img class="top-img" src="assets/svg-icons/bolt.svg" alt="bolt" />
        <h1>{{ site.power }} kW</h1>
      </div>
      {{ 'site.power' | translate }}
    </div>
  </div>

  <div class="section-container">
    <div class="section-header-container">
      <span class="section-header" data-automation="der-overview">
        {{ 'der.overview' | translate }}
      </span>
    </div>

    @if (site?.stores) {
      <monitor-ui-table [stores]="site?.stores"></monitor-ui-table>
    } @else {
      <span class="ml-8">{{ 'site.der.no_data' | translate }}</span>
    }
  </div>

  <div class="section-container mt-8">
    <div class="section-header-container">
      <div class="flex flex-col">
        <span class="section-header" data-automation="site-diagnostic-stats">
          {{ 'advanced.analytics' | translate }}
        </span>
        <span class="subtitle">
          {{ 'analytics.subtitle' | translate }}
        </span>
      </div>
      <button class="mt-4 mr-8 export-button" mat-flat-button color="primary">
        {{ 'analytics.export' | translate }}
      </button>
    </div>

    <div class="m-6 flex items-center justify-between">
      <div class="flex justify-items-start">
        <mat-form-field appearance="outline" class="mr-4">
          <mat-select [(value)]="dateCurrentValue" placeholder="Select a value">
            @for (option of dates; track $index) {
              <mat-option [value]="option">
                {{ option }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Data Interval</mat-label>
          <mat-select
            [(value)]="dateCurrentInterval"
            placeholder="Select a value"
            (selectionChange)="changedInterval()"
          >
            @for (option of intervals; track $index) {
              <mat-option [value]="option">
                {{ option }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>

      <!--      <div class="mb-6">-->
      <!--        {{ 'analytics.graph.refresh' | translate }}-->
      <!--        <mat-slide-toggle color="primary" checked="true"></mat-slide-toggle>-->
      <!--      </div>-->
    </div>

    <mat-divider></mat-divider>

    <mat-accordion class="mr-6">
      <mat-expansion-panel class="custom-panel" expanded>
        <mat-expansion-panel-header>
          <mat-panel-title>{{ 'analytics.graph.overview' | translate }}</mat-panel-title>
        </mat-expansion-panel-header>
        @if (overviewData) {
          <monitor-ui-multi-stat-chart
            [tabs]="overviewData"
            [chartId]="'overview-graph'"
            [minDate]="minDate"
            [maxDate]="maxDate"
          ></monitor-ui-multi-stat-chart>
        }
      </mat-expansion-panel>

      <!--      <mat-expansion-panel class="custom-panel" expanded>-->
      <!--        <mat-expansion-panel-header>-->
      <!--          <mat-panel-title>{{ 'analytics.graph.battery_soc' | translate }}</mat-panel-title>-->
      <!--        </mat-expansion-panel-header>-->
      <!--        &lt;!&ndash; Your chart or content here &ndash;&gt;-->
      <!--      </mat-expansion-panel>-->

      <!--      <mat-expansion-panel class="custom-panel" expanded>-->
      <!--        <mat-expansion-panel-header>-->
      <!--          <mat-panel-title>{{ 'analytics.graph.demand_rates' | translate }}</mat-panel-title>-->
      <!--        </mat-expansion-panel-header>-->
      <!--        &lt;!&ndash; Your chart or content here &ndash;&gt;-->
      <!--      </mat-expansion-panel>-->

      <!--      <mat-expansion-panel class="custom-panel" expanded>-->
      <!--        <mat-expansion-panel-header>-->
      <!--          <mat-panel-title>{{ 'analytics.graph.energy_rates' | translate }}</mat-panel-title>-->
      <!--        </mat-expansion-panel-header>-->
      <!--        &lt;!&ndash; Your chart or content here &ndash;&gt;-->
      <!--      </mat-expansion-panel>-->

      <!--      <mat-expansion-panel class="custom-panel" expanded>-->
      <!--        <mat-expansion-panel-header>-->
      <!--          <mat-panel-title>{{ 'analytics.graph.coincident_peak' | translate }}</mat-panel-title>-->
      <!--        </mat-expansion-panel-header>-->
      <!--        &lt;!&ndash; Your chart or content here &ndash;&gt;-->
      <!--      </mat-expansion-panel>-->
    </mat-accordion>
  </div>

  <!--    <div class="section-header-container">-->
  <!--      <h4 class="section-header">-->
  <!--        {{ 'advanced.analytics' | translate }}-->
  <!--      </h4>-->
  <!--    </div>-->
  <!--    <div class="flex flex-col ml-8">-->
  <!--      <div class="flex flex-col">-->
  <!--        <div>-->
  <!--          <mat-select></mat-select>-->
  <!--          <mat-select></mat-select>-->
  <!--          <mat-select></mat-select>-->
  <!--          <button-->
  <!--            mat-icon-button-->
  <!--            color="accent"-->
  <!--            aria-label="Export"-->
  <!--            class="toggle-sidenav flex justify-center items-center"-->
  <!--            data-automation="advanced-analytics-export"-->
  <!--          >-->
  <!--            <mat-icon>download-new</mat-icon>-->
  <!--            {{ 'export' | translate }}-->
  <!--          </button>-->
  <!--        </div>-->
  <!--      </div>-->

  <!--      <div class="section-header-container">-->
  <!--        <h4 class="section-header">-->
  <!--          <mat-icon>double_arrow</mat-icon>-->
  <!--          {{ 'site.diagnostics.battery-state-of-charge' | translate }}-->
  <!--        </h4>-->
  <!--      </div>-->
  <!--      <monitor-ui-multi-stat-chart-->
  <!--        [entity]="site"-->
  <!--        [stats]="[]"-->
  <!--        [seriesLabels]="['battery.state.of.charge.series']"-->
  <!--        [colors]="['000000']"-->
  <!--        [chartId]="'battery-state-of-charge-chart'"-->
  <!--        [titleKey]="'battery.state.of.charge.chart.title'"-->
  <!--      ></monitor-ui-multi-stat-chart>-->

  <!--      <div class="section-header-container">-->
  <!--        <h4 class="section-header">-->
  <!--          <mat-icon>double_arrow</mat-icon>-->
  <!--          {{ 'site.diagnostics.demand-rates' | translate }}-->
  <!--        </h4>-->
  <!--      </div>-->
  <!--      <monitor-ui-multi-stat-chart-->
  <!--        [entity]="site"-->
  <!--        [stats]="[]"-->
  <!--        [seriesLabels]="['demand.rates.series']"-->
  <!--        [colors]="['000000']"-->
  <!--        [chartId]="'demand-rates-chart'"-->
  <!--        [titleKey]="'demand.rates.chart.title'"-->
  <!--      ></monitor-ui-multi-stat-chart>-->

  <!--      <div class="section-header-container">-->
  <!--        <h4 class="section-header">-->
  <!--          <mat-icon>double_arrow</mat-icon>-->
  <!--          {{ 'site.diagnostics.energy-rates' | translate }}-->
  <!--        </h4>-->
  <!--      </div>-->
  <!--      <monitor-ui-multi-stat-chart-->
  <!--        [entity]="site"-->
  <!--        [stats]="[]"-->
  <!--        [seriesLabels]="['energy.rates.series']"-->
  <!--        [colors]="['000000']"-->
  <!--        [chartId]="'energy-rates-chart'"-->
  <!--        [titleKey]="'profile.chart.y.axis'"-->
  <!--      ></monitor-ui-multi-stat-chart>-->

  <!--      <div class="section-header-container">-->
  <!--        <h4 class="section-header">-->
  <!--          <mat-icon>double_arrow</mat-icon>-->
  <!--          {{ 'site.diagnostics.coincident-peak' | translate }}-->
  <!--        </h4>-->
  <!--      </div>-->
  <!--      <monitor-ui-multi-stat-chart-->
  <!--        [entity]="site"-->
  <!--        [stats]="[]"-->
  <!--        [seriesLabels]="['coincident.peak.series']"-->
  <!--        [colors]="['000000']"-->
  <!--        [chartId]="'coincident-peak-chart'"-->
  <!--        [titleKey]="'coincident.peak.chart.title'"-->
  <!--      ></monitor-ui-multi-stat-chart>-->
  <!--    </div>-->
</div>
